export const urls = {
  launch: () => `/v1/be-practice-interview/launch/`,
}
